import { Component, createElement } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  isAuthenticated: boolean;
  path: string;
  redirectTo?: string;
}

/*
 * Route wrapper that redirects a user to a URL if they are authenticated and
 * try to access a route that requires them to be unauthenticated.
 */
export default class UnprotectedRoute extends Component<Props> {
  static defaultProps: Partial<Props> = {
    redirectTo: '/',
  };

  render() {
    const { component, isAuthenticated, redirectTo, ...rest } = this.props;
    const render = (props: RouteComponentProps) => {
      if (!isAuthenticated) {
        return createElement(component, props);
      }

      const to = {
        pathname: redirectTo,
        search: props.location.search,
        state: { from: props.location },
      };

      return <Redirect to={to} />;
    };

    return <Route {...rest} render={render} />;
  }
}
